import ConfigureEmailSyncRules from './ConfigureEmailSyncRules';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const EmailSyncAdminPageHeader = ({ tenantName }) => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				mb: 2,
			}}
		>
			<Box>
				<Typography
					variant='h5'
					sx={{
						fontWeight: 600,
						fontSize: '18px',
						lineHeight: '28px',
						letterSpacing: '0.15px',
						color: theme.palette.text.primary,
						mb: 0,
					}}
				>
					Email Sync Admin
				</Typography>

				<Typography
					variant='body2'
					sx={{
						letterSpacing: '0.15px',
						fontSize: '12px',
						lineHeight: '20px',
						color: theme.palette.text.secondary,
					}}
				>
					{tenantName}
				</Typography>
			</Box>

			<ConfigureEmailSyncRules />
		</Box>
	);
};

EmailSyncAdminPageHeader.propTypes = {
	tenantName: PropTypes.string.isRequired,
};

export default EmailSyncAdminPageHeader;
